/* tslint:disable */
/* eslint-disable */
/**
 * Api Documentation
 * Api Documentation
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import {
    JsonStratComment,
    JsonStratCommentFromJSON,
    JsonStratCommentFromJSONTyped,
    JsonStratCommentToJSON,
} from './JsonStratComment';

/**
 * 
 * @export
 * @interface ApiResultOfJsonStratComment
 */
export interface ApiResultOfJsonStratComment {
    /**
     * 
     * @type {JsonStratComment}
     * @memberof ApiResultOfJsonStratComment
     */
    data?: JsonStratComment;
    /**
     * 
     * @type {string}
     * @memberof ApiResultOfJsonStratComment
     */
    message?: string;
    /**
     * 
     * @type {object}
     * @memberof ApiResultOfJsonStratComment
     */
    messageValues?: object;
    /**
     * 
     * @type {string}
     * @memberof ApiResultOfJsonStratComment
     */
    requestId?: string;
    /**
     * 
     * @type {string}
     * @memberof ApiResultOfJsonStratComment
     */
    result?: ApiResultOfJsonStratCommentResultEnum;
}

/**
* @export
* @enum {string}
*/
export enum ApiResultOfJsonStratCommentResultEnum {
    Ok = 'OK',
    Error = 'ERROR'
}

export function ApiResultOfJsonStratCommentFromJSON(json: any): ApiResultOfJsonStratComment {
    return ApiResultOfJsonStratCommentFromJSONTyped(json, false);
}

export function ApiResultOfJsonStratCommentFromJSONTyped(json: any, ignoreDiscriminator: boolean): ApiResultOfJsonStratComment {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'data': !exists(json, 'data') ? undefined : JsonStratCommentFromJSON(json['data']),
        'message': !exists(json, 'message') ? undefined : json['message'],
        'messageValues': !exists(json, 'messageValues') ? undefined : json['messageValues'],
        'requestId': !exists(json, 'requestId') ? undefined : json['requestId'],
        'result': !exists(json, 'result') ? undefined : json['result'],
    };
}

export function ApiResultOfJsonStratCommentToJSON(value?: ApiResultOfJsonStratComment | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'data': JsonStratCommentToJSON(value.data),
        'message': value.message,
        'messageValues': value.messageValues,
        'requestId': value.requestId,
        'result': value.result,
    };
}

